export interface Point {
  x: number;
  y: number;
}

export function domGetElemPosition(el: Element): Point {
  let xPos = 0;
  let yPos = 0;

  while (el) {
    const hel: HTMLElement = el as HTMLElement;
    if (el.tagName === 'BODY') {
      // deal with browser quirks with body/window/document and page scroll
      const xScroll = el.scrollLeft || document.documentElement.scrollLeft;
      const yScroll = el.scrollTop || document.documentElement.scrollTop;

      xPos += (hel.offsetLeft - xScroll + el.clientLeft);
      yPos += (hel.offsetTop - yScroll + el.clientTop);
    } else {
      // for all other non-BODY elements
      xPos += (hel.offsetLeft - el.scrollLeft + el.clientLeft);
      yPos += (hel.offsetTop - el.scrollTop + el.clientTop);
    }

    el = hel.offsetParent as Element;
  }
  return {
    x: xPos,
    y: yPos
  };
}

/**
 * Renvoie la hauteur en pixels de l'élément du DOM dont l'id est passé en paramètre.
 * Si l'élément n'est pas trouvé, renvoie NULL.
 * @param elemId Id de l'élément du DOM
 * @param bottonMargin Offset
 * @param defaultHeight Hauteur par défaut si l'élément DOM n'est pas trouvé
 */
export function ajustHeight(elemId: string, bottonMargin: number, defaultHeight: number = 400) {
  const innerHeight = window.innerHeight;
  const elem: HTMLDivElement = document.getElementById(elemId) as HTMLDivElement;
  if (elem) {
    const offsetElem = domGetElemPosition(elem);
    // console.log (`VH:${innerHeight}, Ey:${offsetElem.y}, Of:${bottonMargin}`);
    return innerHeight - offsetElem.y - bottonMargin;
  }
  return defaultHeight;
}

// export function ajustHeight()
